module.exports = __webpack_public_path__ + "static/media/21.c4ae7e5c.png";